import axios from 'axios';
import {IVerifyFile} from "/react4xp/parts/manage-reestr-list/manage-reestr-list.type";

const historyUrl = `/services/isnaportal/open-api/admin/document-history`;
const HISTORY_PAGE_SIZE = 5;

export const getHistory = (id: number, pageNumber = 1, pageSize = HISTORY_PAGE_SIZE) => {
    return axios
        .get(
            `${historyUrl}/${id}/events?sort=createdDate,desc&size=${pageSize}&page=${
                pageNumber - 1
            }`
        )
        .then((res) => res.data);
};

export const validateHistoryFile = (data: IVerifyFile, config: any) => {
    return axios.post(`${historyUrl}/validate`, data, config);
};
